import { render, staticRenderFns } from "./platinvoicingtasklist-add.vue?vue&type=template&id=75f7d614&scoped=true&"
import script from "./platinvoicingtasklist-add.vue?vue&type=script&lang=js&"
export * from "./platinvoicingtasklist-add.vue?vue&type=script&lang=js&"
import style0 from "./platinvoicingtasklist-add.vue?vue&type=style&index=0&id=75f7d614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f7d614",
  null
  
)

export default component.exports